import { useEffect } from "react"
import { useGlobalsStore } from "../providers/GlobalsProvider"
import useCustomStore from "./useCustomStore"

export function useGlobals(selector) {
	return useCustomStore(useGlobalsStore, selector)
}

export function useInitGlobals(globals) {
	const setGlobals = useGlobalsStore((s) => s.setGlobals)

	useEffect(() => {
		if (globals) {
			setGlobals(globals)
		}
	}, [globals, setGlobals])
}
